import type { UnifiedThemeType } from '@oneaudi/unified-web-common';
import { SYS_COLOR_CANVAS_200_DARK } from '@oneaudi/unified-web-alpha-common';

export enum CTAsTheme {
  Dark = 'Dark',
  Light = 'Light',
  Media = 'Media',
}
type GetDesignLibraryProps = {
  unifiedWebCommonVersion?: string;
  unifiedWebAlphaCommonVersion?: string;
};

export const getDesignLibrary = (props?: GetDesignLibraryProps): { [key: string]: string } => {
  if (process.env.IS_LEGACY) {
    return { '@oneaudi/unified-web-common': props?.unifiedWebCommonVersion || '*' };
  }
  return { '@oneaudi/unified-web-alpha-common': props?.unifiedWebAlphaCommonVersion || '*' };
};

export const getThemeName = (
  defaultThemeName?: UnifiedThemeType['name'],
): UnifiedThemeType['name'] => {
  if (process.env.IS_LEGACY) {
    return defaultThemeName || 'light';
  }
  return 'dark';
};

export const getBackgroundColor = (themeColor?: CTAsTheme) => {
  if (process.env.IS_LEGACY) {
    return themeColor === CTAsTheme.Light ? 'white' : 'black';
  }
  return SYS_COLOR_CANVAS_200_DARK;
};
